import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getMeApi, loginWithOtpApi, sendOtpApi, updateMeApi } from '../../api/auth.api';
import { loadAppState } from '../../utils/storage';

const persistedState = loadAppState();

export const sendOtp = createAsyncThunk('auth/sendOtp', async (mobile) => {
  return sendOtpApi(mobile);
});

export const loginWithOtp = createAsyncThunk('auth/loginWithOtp', async ({ mobile, otpCode }) => {
  return loginWithOtpApi({ mobile, otpCode });
});

export const fetchProfile = createAsyncThunk('auth/fetchProfile', async () => getMeApi());

export const updateProfile = createAsyncThunk('auth/updateProfile', async (payload) => updateMeApi(payload));

const authSlice = createSlice({
  name: 'auth',
  initialState: persistedState.auth,
  reducers: {
    setAuthMode: (state, action) => {
      state.authMode = action.payload;
      state.error = null;
    },
    setMobile: (state, action) => {
      state.mobile = action.payload;
      state.error = null;
    },
    clearAuthError: (state) => {
      state.error = null;
    },
    setUser: (state, action) => {
      state.user = action.payload;
    },
    logout: (state) => {
      state.isAuthenticated = false;
      state.user = null;
      state.authMode = 'login';
      state.accessToken = null;
      state.otpSent = false;
      state.otpCode = null;
      state.mobile = '';
      state.error = null;
      state.otpRequestedAt = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(sendOtp.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(sendOtp.fulfilled, (state, action) => {
        state.loading = false;
        state.otpSent = true;
        state.otpCode = null;
        state.mobile = action.payload.mobile;
        state.otpExpiresInSeconds = action.payload.expiresInSeconds || 120;
        state.otpRequestedAt = Date.now();
      })
      .addCase(sendOtp.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'OTP request failed';
      })
      .addCase(loginWithOtp.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(loginWithOtp.fulfilled, (state, action) => {
        state.loading = false;
        state.isAuthenticated = true;
        state.user = action.payload.user;
        state.accessToken = action.payload.accessToken;
        state.otpSent = false;
        state.otpCode = null;
        state.otpRequestedAt = null;
      })
      .addCase(loginWithOtp.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Login failed';
      })
      .addCase(fetchProfile.fulfilled, (state, action) => {
        state.user = action.payload;
      })
      .addCase(updateProfile.fulfilled, (state, action) => {
        state.user = action.payload;
      });
  }
});

export const { clearAuthError, logout, setAuthMode, setMobile, setUser } = authSlice.actions;
export default authSlice.reducer;
